<div class="row" [formGroup]="recieverAddressGroup">
  <div class="col-md-4 form-group">
    <label class="required-field"> Save Receiver Address</label>:
    <select class="form-control" formControlName="saveAddress">
      <option disabled value="">
        {{ 'configuration.customerOnboarding.select' | translate }}
      </option>
      <option *ngFor="let eachListVal of saveRecieverAddressList" [value]="eachListVal">
        {{ eachListVal }}
      </option>
    </select>
  </div>

  <div class="col-12 mb-2 text-end">
    <button
      [disabled]="!(recieverAddressGroup.valid && recieverAddressGroup.dirty)"
      class="primary-btn mt-2"
      (click)="saveRecieverAddress()">
      {{ 'global.save' | translate }}
    </button>
  </div>
</div>
